import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M17.5 17.5H2.5M15 9.16667L10 14.1667M10 14.1667L5 9.16667M10 14.1667V2.5" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);